import { UseQueryResult, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";
import { useOktaAuth } from "@okta/okta-react";
import OrganizationsResponse from "../../models/API/responseModels/organzationsResponse.model";
import OrganizationDetailModel from "../../models/API/responseModels/organizationDetailResponse.model";
import { useContext } from "react";
import { ApplicationState } from "../../context/ApplicationStateContext";

function useOrganizations(): UseQueryResult<OrganizationsResponse, any> {
  const authState = useOktaAuth()?.authState;
  const { dispatch } = useContext(ApplicationState);
  const maskedPhone = (phone: string) => {
    const phoneString = phone.replace(/-/g, "");
    return `${!!phoneString?.[0] ? phoneString?.[0] : ""}${
      !!phoneString?.[1] ? phoneString?.[1] : ""
    }${!!phoneString?.[2] ? phoneString?.[2] : ""}-${
      !!phoneString?.[3] ? phoneString?.[3] : ""
    }${!!phoneString?.[4] ? phoneString?.[4] : ""}${
      !!phoneString?.[5] ? phoneString?.[5] : ""
    }-${!!phoneString?.[6] ? phoneString?.[6] : ""}${
      !!phoneString?.[7] ? phoneString?.[7] : ""
    }${!!phoneString?.[8] ? phoneString?.[8] : ""}${
      !!phoneString?.[9] ? phoneString?.[9] : ""
    }`;
  };

  return useQuery({
    queryKey: ["organizations"],
    queryFn: () =>
      axiosInstance
        .get("/v1/organizations/new-flow/list", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
          transformResponse: (res) => {
            let response = JSON.parse(res);

            if (response?.data?.length > 0) {
              // dispatch({
              //   type: "SET_ORGANIZATION",
              //   payload: response.data[0].id,
              // });
              // dispatch({
              //   type: "SET_ORGANIZATION_DATA",
              //   payload: response.data[0],
              // });
              
              response = {
                ...response,
                data: response?.data?.map((org: OrganizationDetailModel) => ({
                  ...org,
                  phone: maskedPhone(org.phone),
                  fax: maskedPhone(org.fax),
                })),
              };
            }
            return response;
          },
        })
        .then((res) => res?.data),
    enabled: !!authState?.accessToken?.accessToken,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}

export default useOrganizations;
